module.exports = require('./ForgotPasswordPhoneNumber')